<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-key2`]" width="1em" height="1em" v-bind="$attrs"><path d="M5.65276 1.09529C5.91245 0.835588 6.33349 0.835588 6.59319 1.09529C6.85252 1.35501 6.85276 1.77614 6.59319 2.03572L4.60783 4.02107L7.0844 6.49763C8.95868 5.08104 11.6375 5.22509 13.3461 6.93318C15.2142 8.80129 15.2142 11.8317 13.3461 13.6998C11.478 15.5675 8.44846 15.5668 6.58049 13.6988C4.87259 11.9904 4.72792 9.31226 6.14397 7.43806L1.44768 2.74177C1.18808 2.48208 1.18805 2.06102 1.44768 1.80134C1.70735 1.54167 2.1284 1.54173 2.38811 1.80134L3.6674 3.08064L5.65276 1.09529ZM12.4057 7.87458C11.0569 6.52618 8.86953 6.52597 7.52092 7.87458C6.17279 9.22317 6.17283 11.4098 7.52092 12.7584C8.86949 14.1069 11.0569 14.1076 12.4057 12.7593C13.7543 11.4107 13.7541 9.22332 12.4057 7.87458Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineKey2',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
